<script>
    export default {
        created() {
            this.loadDiskUsage();
        },
        data() {
            return {
                disks: {},
            }
        },
        methods: {
            loadDiskUsage() {
                axios.get(`${Scoop.baseUrl}/api/components/diskUsage`).then(response => {
                    this.disks = response.data;
                })
            },
        },
    }
</script>

<template>
    <div class="ibox">
        <div class="ibox-title">
            <h5>Disk usage</h5>
        </div>
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-4">
                    <small class="stats-label" v-text="__('scoop-os.diskusage.name')"></small>
                </div>
                <div class="col-sm-4">
                    <small class="stats-label" v-text="__('scoop-os.diskusage.used')"></small>
                </div>
                <div class="col-sm-4">
                    <small class="stats-label" v-text="__('scoop-os.diskusage.free')"></small>
                </div>
            </div>
            <div class="row" v-for="disk in disks" v-if="disks && disks.length > 0">
                <div class="col-sm-4">
                    <h4 v-text="disk.name"></h4>
                </div>
                <div class="col-sm-4">
                    <h4 v-text="disk.used"></h4>
                </div>
                <div class="col-sm-4">
                    <h4 v-text="disk.free"></h4>
                </div>
            </div>
        </div>
    </div>
</template>
